import { useMemo } from "react";

export const useTemplateTypeOptions = (category) => {
  return useMemo(() => {
    switch (category) {
      case "marketing":
        return [
          { value: "custom_message", label: "Custom Message", desc: "Send promotional offers, announcements..." },
          //{ value: "product_message", label: "Product Message", desc: "Send messages about your entire catalogue..." },
          { value: "carousel", label: "Carousel", desc: "You can send up to 10 carousel cards..." },
          //{ value: "lto", label: "Limited Time Offer (LTO)", desc: "Display expiration dates..." },
          //{ value: "flow", label: "Flow", desc: "Send a form to capture interests...", disabled: true },
        ];

      case "utility":
        return [
          { value: "custom_message", label: "Custom Message", desc: "Send transactional or info messages..." },
          //{ value: "flow", label: "Flow", desc: "Send a form to capture info...", disabled: true },
        ];

      case "authentication":
        return [
          { value: "otp_message", label: "OTP Message", desc: "Send verification codes." },
          { value: "security_notification", label: "Security Notification", desc: "Send login or password reset alerts." },
        ];

      default:
        return [];
    }
  }, [category]);
};
